const gTagConstants = {
  eventKeys: {
    recently_signed_in: 'global_log_in',
    recently_signed_up: 'global_sign_up',
  },
};

export default gTagConstants;
